/*       */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@mic3/platform-ui';

import { loadPipelineMonitor } from 'store/actions/designer/designerPipelineActions';
import { bind } from 'app/utils/decorators/decoratorUtils';
import withPermissions from 'app/utils/withPermissions';

import StartPipeline from 'app/components/Designer/Modals/StartPipeline';
import PageTemplate from 'app/components/templates/PageTemplate';
import Layout from 'app/components/molecules/Layout/Layout';
import Icon from 'app/components/atoms/Icon/Icon';
import EntitiesList from 'app/containers/Entities/EntitiesList/EntitiesList';
import Alert from 'app/components/molecules/Alert/Alert';
import { commonEntitiesListFilters } from 'app/utils/entity/entityUtils';
import { setDocumentTitle } from 'store/actions/app/appActions';
import { modulesAndPageTitles } from 'app/config/typesConfig';

const IconStyled = styled(Icon)`
    &:before {
        color: ${({ theme }) => theme.material.colors.text.caption};
        font-size: 6rem !important;
        font-weight: 100 !important;
        @media (max-width: 480px) {
            margin-left: 1rem;
        }
    }
`;

const Contaienr = styled.div`
    display: flex;
    justify-content: space-around;
    height: calc(100vh - 205px);
`;

const StartedText = styled.div`
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 100;
    font-size: 60px;
    line-height: 68px;
    letter-spacing: -0.5px;
    color: ${({ theme }) => theme.material.colors.text.caption};
    margin-left: 2rem;
`;

const Flex = styled.div`
    display: flex;
    align-items: center;
`;

const PageTemplateWrapper = styled('div')`
    height: 100%;
    & .page-content {
        height: 100%;
    }
`;

const VIEW_ID = 'PipelineMonitor';

class PipelineMonitor extends PureComponent {
    virtualListRef = React.createRef();

    static propTypes = {
        isLoading: PropTypes.bool,
        records: PropTypes.array,
        startIndex: PropTypes.number,
        totalRecords: PropTypes.number,
        loadPipelineMonitor: PropTypes.func.isRequired,
        createPipeline: PropTypes.func.isRequired,
    };

    state = { isAddPipelineOpen: false };

    breadcrumb = [{ title: 'Pipeline Builder' }];
    searchBar = ['name', 'id'];
    options = {};

    defaultFilters = { active: true };
    filterDefinitions = [
        { field: 'name', type: 'text', properties: { label: 'Name', name: 'name' } },
        { field: 'id', type: 'uuid', properties: { label: 'ID', name: 'id' } },
        ...commonEntitiesListFilters,
    ];
    defaultOrder = [{ field: 'createdDate', direction: 'desc nulls last' }];

    columnDefinitions = [
        { text: 'Entity Name', field: 'name' },
        { text: 'Description', field: 'description' },
        { text: 'Entity ID', field: 'id', onClickDisabled: true },
        { text: 'Last Updated', field: 'modifiedDate' },
        { text: 'Modified By', field: 'modifiedBy' },
        { text: 'Created Date', field: 'createdDate' },
        { text: 'Created by', field: 'createdBy' },
    ];

    componentDidMount() {
        this.props.setDocumentTitle(modulesAndPageTitles.miStream.pipelineMonitor);
    }

    @bind
    toggleStartPipeline() {
        this.setState({ isAddPipelineOpen: !this.state.isAddPipelineOpen });
    }

    @bind
    handleLoadPipelineMonitor(options) {
        const { loadPipelineMonitor } = this.props;
        if (options) {
            this.options = options;
        }
        return loadPipelineMonitor(this.options);
    }

    @bind
    renderNoResultComponent(filterBy) {
        const { canAdd } = this.props;

        if (filterBy && filterBy.length > 0) {
            return (
                <Alert type="background" margin={16}>
                    No results
                </Alert>
            );
        }
        return (
            <PageTemplateWrapper title={'IoT Pipeline Monitor'}>
                <PageTemplate title={'IoT Pipeline Monitor'}>
                    <Contaienr>
                        <Flex>
                            <div style={{ display: 'flex', textAlign: 'initial' }}>
                                <IconStyled style={{ lineHeight: '70px' }} name="plus" />
                                <StartedText>
                                    Let's get started
                                    <br />
                                    {canAdd && (
                                        <Button variant="text" onClick={this.toggleStartPipeline}>
                                            Start pipeline
                                        </Button>
                                    )}
                                </StartedText>
                            </div>
                        </Flex>
                    </Contaienr>
                </PageTemplate>
            </PageTemplateWrapper>
        );
    }

    render() {
        const { totalRecords, records, isLoading, startIndex, canAdd } = this.props;
        const { isAddPipelineOpen } = this.state;

        return (
            <PageTemplate title="IoT Pipeline Monitor">
                <Layout>
                    <EntitiesList
                        pageViewId={VIEW_ID}
                        id={VIEW_ID}
                        ref={this.listRef}
                        type={'iot_pipeline'}
                        headerTitle="IoT Pipeline Monitor"
                        records={records}
                        totalRecords={totalRecords}
                        startIndex={startIndex}
                        isLoading={isLoading}
                        loadData={this.handleLoadPipelineMonitor}
                        columnDefinitions={this.columnDefinitions}
                        filterDefinitions={this.filterDefinitions}
                        defaultFilters={this.defaultFilters}
                        location={location}
                        canAdd={canAdd}
                        pipelineMonitor
                        VirtualListCardsProps={{
                            renderNoResultComponent: this.renderNoResultComponent,
                        }}
                        VirtualListProps={{
                            renderNoResultComponent: this.renderNoResultComponent,
                        }}
                    />
                </Layout>
                {isAddPipelineOpen && <StartPipeline reloadList={this.handleLoadPipelineMonitor} onClose={this.toggleStartPipeline} />}
            </PageTemplate>
        );
    }
}

export default connect(
    state => ({
        isLoading: state.designer.pipelineMonitor.isLoading,
        startIndex: state.designer.pipelineMonitor.startIndex,
        records: state.designer.pipelineMonitor.records,
        totalRecords: state.designer.pipelineMonitor.count,
        userProfile: state.user.profile,
    }),
    {
        loadPipelineMonitor,
        setDocumentTitle,
    }
)(withPermissions(PipelineMonitor, 'iot_pipeline'));
